<script>

    export let src;
    export let alt;
    let clazz = '';
    export {clazz as class};

    import { fade } from 'svelte/transition';

    function preload(src) {
        return new Promise(function(resolve) {
            let img = new Image();
            img.onload = resolve;
            img.src = src;
        });
    }
</script>

{#await preload(src) then _}
    <img class={clazz} {src} in:fade {alt}/>
{/await}